import { Component, OnInit, Input } from '@angular/core';
import { DiaryEventGroup } from "../../models/diary-event-group"
import { DiaryEvent } from "../../models/diary-event"

@Component({
  selector: 'mojo-diary-events',
  templateUrl: './diary-events.component.html',
  styleUrls: ['./diary-events.component.scss']
})

export class DiaryEventsComponent implements OnInit {
  selectedEvent: DiaryEvent = undefined;
  private _diaryEvents: DiaryEventGroup[] = [];

  @Input() isUndated: boolean = false;
  @Input() set diaryEvents(value: DiaryEventGroup[]) {
    this._diaryEvents = value;
    this.selectedEvent = undefined;
  }
  get diaryEvents(): DiaryEventGroup[] {
    return this._diaryEvents;
  }

  constructor() {
  }

  ngOnInit() {
  }

  diaryEventClicked(dairyEvent: DiaryEvent) {
    this.selectedEvent = dairyEvent;
  }

  clearSelectedDiaryEvent(event:any) {
    this.selectedEvent = undefined;
  }

}
